import { ReactNode, useMemo } from "react";
import moment from "moment";
import XTermLog, { LogEntry } from "./XTermLog";

interface LogsProps {
    title?: ReactNode;
    extra?: ReactNode;
    logs?: string[];
    height?: string;
    limit?: number;
    onSelect?: (timestamp: number) => void;
}

// @ts-ignore
const timestampRegex = /^(?<isoDate>\b[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}.\d+Z\b)|^(?<isoDate1>\b[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}\+[0-9]{2}:[0-9]{2}\b)|^(?<isoDate2>\b[0-9]{4}\/[0-9]{2}\/[0-9]{2} [0-9]{2}:[0-9]{2}:[0-9]{2}\.[0-9]+\b)|^\[(?<timestamp>\d+)\]|^\[(?<date>.*)\]/;

function parseLogLine(line: string): LogEntry {
    const match = timestampRegex.exec(line);
    if (!match) return { content: line };

    const logTime = match[0];
    const date = match.groups?.timestamp
        ? parseInt(match.groups.timestamp)
        : match.groups?.isoDate || match.groups?.isoDate1 || match.groups?.isoDate2 || match.groups?.date || "";

    if (!moment(date).isValid()) return { content: line };

    const formatted = moment.utc(date).local().format("MMM DD HH:mm:ss.SSS");
    const content = line.replace(logTime, "");
    return { timestamp: formatted, content };
}

const Logs = ({
    title,
    extra,
    logs = [],
    height,
    limit,
}: LogsProps) => {
    const entries = useMemo(
        () => (limit ? logs.slice(0, limit) : logs).map(parseLogLine),
        [logs, limit]
    );

    return (
        <XTermLog
            logs={entries}
            height={height}
            title={title}
            extra={extra}
            className="content-logs"
        />
    );
}

export default Logs;
